module.exports = __webpack_public_path__ + "static/media/2022_headshot.91c57402.jpg";